import { render, staticRenderFns } from "./AntiBan.vue?vue&type=template&id=0fa98a1a"
import script from "./AntiBan.vue?vue&type=script&lang=js"
export * from "./AntiBan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports